
import { getBase64, getFileExtension } from "../../../utils/Utils";
import { uploadFileV2 } from "../../../utils/SendFile";

function findModelElementByUploadId(editor, uploadId) {
  const root = editor.model.document.getRoot();
  const range = editor.model.createRangeIn(root);

  for (const value of range.getWalker()) {
    const item = value.item;

    if (
      value.type === "elementStart" &&
      (item.is("element", "imageBlock") || item.is("element", "imageInline"))
    ) {
      if (item.getAttribute("uploadId") === uploadId) {
        return item;
      }
    }
  }
  return null;
}

export const UploadAdapterPlugin = (editor, conversationId) => {
  editor.plugins.get("FileRepository").createUploadAdapter = (loader) => {
    return createUploadAdapter(loader, conversationId, editor);
  };
};

const createUploadAdapter = (loader, conversationId, editor) => {
  return {
    upload: async () => {
      const uploadId = loader.id;

      try {
        const file = await loader.file;
        const base64Data = await getBase64(file);

        const controller = new AbortController();
        const savedImageRes = await uploadFileV2(
          file,
          conversationId,
          "FREE",
          controller.signal,
        );

        if (savedImageRes?.resourceId) {
          const resourceId = savedImageRes?.resourceId;

          const modelImg = findModelElementByUploadId(editor, uploadId);

          if (modelImg) {
            editor.model.change((writer) => {
              writer.setAttribute("data-resource-id", resourceId, modelImg);
            });
          } else {
            console.error(
              "UploadAdapter: Không tìm thấy model element cho uploadId:",
              uploadId,
            );
          }

          return {
            default: base64Data,
          };
        }

        throw new Error("Upload failed. Image not inserted.");
      } catch (error) {
        console.error("UploadAdapter error:", error);
        throw new Error("Upload failed. Image not inserted.");
      }
    },

    abort: () => {
      const modelImg = findModelElementByUploadId(editor, loader.id);
      if (modelImg) {
        editor.model.change((writer) => {
          writer.setAttribute("uploadStatus", "aborted", modelImg);
        });
      }
    },
  };
};
